'use strict';

var arrayWithoutHoles$1 = require('./arrayWithoutHoles.js');
var iterableToArray$1 = require('./iterableToArray.js');
var nonIterableSpread$1 = require('./nonIterableSpread.js');

var arrayWithoutHoles = arrayWithoutHoles$1;

var iterableToArray = iterableToArray$1;

var nonIterableSpread = nonIterableSpread$1;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

module.exports = toConsumableArray;
